import { SanityDocument } from '@sanity/client';
import { useSanity } from '../../../../hooks/useSanity';
import { Typography, Box } from '@mui/material';
import { Link } from 'react-router';
import { determineLinkForwarding } from '../../../../utils/footer';
import StyledSkeleton from '../../../atoms/StyledSkeleton';
import { StyleObj } from '../../../../@types';
import useLocalization from '../../../../hooks/useLocalization';

const styles: StyleObj = {
  footerWrapper: {
    pt: 0.5,
  },
  linkWrapper: {
    textAlign: 'justify',
    fontSize: 12,
    color: 'neutral.100',
    display: 'flex',
    justifyContent: 'space-evenly',
    maxWidth: 300,
    margin: '10px auto',
  },
  linkBox: {
    textDecoration: 'inherit',
    color: 'inherit',
    textAlign: 'center',
  },
  consentText: {
    textAlign: 'center',
    fontSize: 10,
    lineHeight: 2,
    color: 'neutral.100',
    my: 2,
  },
};

const CMSFooterContent = () => {
  const { t } = useLocalization();
  const { data: cmsContent, isLoading } = useSanity<SanityDocument>('PortableTextContent');
  const currentYear = new Date().getFullYear();

  if (isLoading) {
    return <StyledSkeleton width={'100%'} height={100} />;
  }

  return (
    <Box sx={styles.footerWrapper}>
      <Typography sx={styles.linkWrapper}>
        {cmsContent?.map((item) => {
          return (
            <Box component={Link} to={determineLinkForwarding(item)} sx={styles.linkBox} key={item._id}>
              {item.title}
            </Box>
          );
        })}
      </Typography>
      <Typography sx={styles.consentText}>{t('consentCookies')}</Typography>
      <Typography sx={styles.consentText}>{t('responsibilityDisclaimer')}</Typography>
      <Typography sx={styles.consentText}>
        &copy; 2024 - {currentYear} {t('copyRights')}
      </Typography>
    </Box>
  );
};

export default CMSFooterContent;
